import { render, staticRenderFns } from "./BillsDetailed.vue?vue&type=template&id=3eb62dd2&scoped=true&"
import script from "./BillsDetailed.vue?vue&type=script&lang=js&"
export * from "./BillsDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb62dd2",
  null
  
)

export default component.exports